import { IStackTokens, IStyle, memoizeFunction, mergeStyleSets } from '@fluentui/react';
import { useScreen } from 'common/hooks/useScreen';

const getStyles = memoizeFunction((isMobileScreen: boolean) =>
  mergeStyleSets({
    pageWrapper: {
      padding: isMobileScreen ? 24 : '16px 32px 40px 32px',
    } as IStyle,
    card: {
      padding: isMobileScreen ? '12px 24px 24px 24px' : '12px 32px 36px 32px',
    } as IStyle,
    cardContentWrapper: {
      textAlign: 'center',
    } as IStyle,
    productNameWrapper: {
      display: 'flex',
    } as IStyle,
    text: {
      textAlign: 'center',
    } as IStyle,
    logoHeading: {
      padding: '12px 0px',
    } as IStyle,
    buttonSection: {
      textAlign: 'center',
    } as IStyle,
    button: {
      minWidth: 300,
      minHeight: 42,
      borderRadius: 24,
    } as IStyle,
    flexButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    } as IStyle,
  })
);

export const useStyles = () => {
  const { isMobileScreen } = useScreen();
  return getStyles(isMobileScreen);
};

export const stackTokens = {
  pageWrapper: {
    childrenGap: 48,
  } as IStackTokens,
  cardContentWrapper: {
    childrenGap: 24,
  } as IStackTokens,
  logoHeading: {
    childrenGap: 12,
  } as IStackTokens,
  cardContent: {
    childrenGap: 12,
  } as IStackTokens,
  buttonSection: {
    childrenGap: 12,
  } as IStackTokens,
  footer: {
    childrenGap: 24,
  } as IStackTokens,
};
